module.exports = {"Born1":{"daobanList":[{"title":"1:是否办理个体工商户设立登记","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、《个体工商户登记（备案）申请书》","state":"必要"},{"name":"2、经营者身份证件复印件","state":"必要"},{"name":"3、经营场所使用相关文件","state":"必要"},{"name":"4、法律、行政法规和国务院决定规定在登记前须报经批准的或申请登记的经营范围中有法律、行政法规和国务院决定规定须在登记前报经批准的项目，提交有关批准文件或者许可证件的复印件","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx31.json
// module id = 1328
// module chunks = 0